export const EXLY_CONNECT_APIS = {
  fetch_schedule: "host/upcoming/exlycon",
  fetch_ondemand_schedule: "host/exlycon/meetings/ondemand",
  broadcast_exly_con_reminders: "host/send/exlycon/reminders",
  get_backup_zoom_link: "host/exlycon/get/zoomlink",
  create_backup_zoom_link: "host/exlycon/create/zoomlink",
  fetch_customer_zoom_link: "host/fetch/exlycon/url",
  check_user_validity: "host/exlyconnect/validity/check",
};
